import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('search-contacts')
export class SimpleGreeting extends LitElement {
	static styles = css`

	p{
		font-size:15px !important;
			line-height: 1.6rem;
	}

 

	a{
		text-decoration:none;
		color: var(--color-primary);
	}

	.card{
		width:100%;
		a{
		text-decoration:underline;
		}

		.card-title{
			font-size:24px;
			line-height:2rem;
			text-transform:uppercase;
		}
	}

	h3{
		margin-top:3px;
		margin-bottom:5px;
		font-size:1.25rem;
	}

	h4{
		text-transform:uppercase;
	}


	.alert{
		max-width: 936px;
	}

	.input-group-text{
		background-color: transparent;
		border-right: none !important;
		color: var(--color-primary);
	}

	.input-group .form-control{
		border-left: none !important;
	}

	.search-input{
		/*max-width:800px;*/
		width: calc(100% - 180px);
		display: inline-block;
	}

	.btn-primary{
		--bs-btn-bg: var(--color-primary);
		--bs-btn-border-color: var(--color-primary);
		--bs-btn-hover-bg: #FFF;
		--bs-btn-hover-border-color: var(--color-primary);
		--bs-btn-hover-color: var(--color-primary);
	
	}
  `;

	@property()
	loaded = false;

	@property()
	stylesheetUrl: string = "";

	@property()
	category?: string = "";

	@property()
	public items: ContactInfo[] = [];

	@property()
	public searchTerm: string = "";

	firstUpdated() {
		this.search();

	}


	search() {
		this.loaded = false;


		fetch(`/api/portal/listContacts`, {
			method: 'POST', // Specify the HTTP method as POST
			headers: {
				'Content-Type': 'application/json' // Set the content type of the request body
			},
			body: JSON.stringify({
				categoryId: this.category,
				searchTerm: this.searchTerm
			}) // Convert the JavaScript object to a JSON string
		})
			.then(response => {
				if (!response.ok) {
					throw new Error(`HTTP error! status: ${response.status}`);
				}
				return response.json();
			})
			.then(data => {

				this.items = data;


			})
			.catch(error => {

				console.error('Error:', error); // Handle any errors that occurred during the fetch
			}).finally(() => {
				this.loaded = true;
			});

		this.dispatchEvent(new CustomEvent('SearchEvent', {
			detail: {
				categoryId: this.category,
				searchTerm: this.searchTerm
			},
			bubbles: true,
			composed: true
		})
		);
	}

	handleInput(e: any) {
		console.log(e);
		this.searchTerm = e.target.value;
	}




	// Render the UI as a function of component state
	render() {
		return html`
		<link href="/CSS/Libs/fontawesome-pro-6.2.0/css/fontawesome.css" rel="stylesheet" />
		<link href="/CSS/Libs/fontawesome-pro-6.2.0/css/solid.css" rel="stylesheet" />
		<link href="/CSS/Libs/bootstrap-5.2/css/bootstrap.min.css" rel="stylesheet" />


		

		
		<div class="search-input">
		<div class="input-group">
		  <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-magnifying-glass"></i></span>
		  <input type="text" .value=${this.searchTerm} class="form-control" aria-label="Search" placeholder="Search" @input=${this.handleInput} @keydown=${(event: any) => { if (event.key == "Enter") { this.search() } }}> 
		</div>
</div>
<button class="btn btn-primary" style="transform:translateY(-2px);" @click=${this.search}>Search</button>&nbsp;<button class="btn btn-secondary" style="transform:translateY(-2px);" @click=${() => { this.searchTerm = ""; this.search() }}>clear</button>





<div class="alert alert-primary my-5" ?hidden=${this.items.length > 0 && this.loaded}>No results found</div>


<h4 class="mt-5" ?hidden=${this.items.filter(item => item.contactTypes == "Contact").length == 0}>Consultants<h1/>
<div class="row">

    ${this.items.filter(item => item.contactTypes == "Contact").map((item) =>
			this.renderCard(item)
		)}
  </div>
 
</div>


<h4 class="mt-5" ?hidden=${this.items.filter(item => item.contactTypes == "Trade").length == 0}>Trades<h1/>
<div class="row">

    ${this.items.filter(item => item.contactTypes == "Trade").map((item) =>
			this.renderCard(item)
		)}
  </div>
 
</div>


	  `;
	}


	renderCard(item: ContactInfo) {
		return html`
  <div class="col-md-6 col-lg-3 d-flex mb-4">
   

  <div class="card">
      <div class="card-body">
       <h2 class="card-title">${item.title}</h2>
      <div class="card-text">
                    <p><strong>${item.companyName}</strong></p>
<p><a href="tel:${item.phone}">${item.phone}</a><br>
<a href="mailto:${item.email}">${item.email}</a><br>
<a href="https://${item.website}" target="_blank">${item.website}</a></p>

${item.website ? html`
<p><a href="https://www.google.com/maps/search/?api=1&query=${item.address}" target="_blank" style="white-space:pre">${item.address}</a></p>` : null}

                </div>
      </div>
    </div>`
	}
}

export class ContactInfo {
	public title: string = "";
	public companyName: string = "";
	public contactTypes: string = "";
	public address: string = "";
	public email: string = "";
	public phone: string = "";
	public website: string = "";
}